import 'core-js/fn/array/from'
import 'core-js/fn/object/assign'
import 'core-js/fn/array/find-index'
import 'core-js/fn/promise'

import './polyfill/element/closest'

import svg4everybody from 'svg4everybody'
svg4everybody()

import 'js-breakpoints'

import optimizeEvents from './events'
optimizeEvents(['scroll', 'resize'])

// Responsive images + Lazy loading
document.createElement('picture');
require('picturefill');
// `object-fit` polyfill
// https://github.com/aFarkas/lazysizes/tree/gh-pages/plugins/object-fit
require('lazysizes/plugins/object-fit/ls.object-fit');
require('lazysizes/plugins/parent-fit/ls.parent-fit');
require('lazysizes/plugins/respimg/ls.respimg');
require('lazysizes');

import nav from './nav'
nav.init()
window.nav = nav

import './helpers/masonry'

window.toggleMomentsThatMove = function(show) {
  const homeHeroContainer = document.querySelector('.page.home .hero')
  const mmContainer = document.querySelector('.page.home .opening-title')

  if (!mmContainer) {
    return;
  }

  const mmH1 = mmContainer.querySelector('h1')

  if (show) {
    mmContainer.classList.add('js-animation-ready')
    mmContainer.classList.add('u-fade-away')
    Array.from(mmContainer.querySelectorAll('.js-has-animation'))
      .forEach((elem) => elem.classList.add('js-animation-ready'))

    setTimeout(function() {
      toggleMomentsThatMove(false)
    }, 4000);
    return;
  }

  mmContainer.classList.remove('js-animation-ready')
  mmContainer.classList.remove('u-fade-away')
  Array.from(mmContainer.querySelectorAll('.js-animation-ready'))
    .forEach((elem) => elem.classList.remove('js-animation-ready'))
}

import './motion'
import './sticky'
import './smooth-scroll'
